import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./Redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "bootstrap/dist/css/bootstrap.min.css";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { SnackbarProvider } from 'notistack';
import { ErrorBoundary } from './shared/components';
import Loader from "@features/shared/components/Loader";

const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <SnackbarProvider
            maxSnacks={3}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            autoHideDuration={4000}
            preventDuplicate
          >
            <Router>
              <PersistGate loading={<Loader />} persistor={persistor}>
                <App />
              </PersistGate>
            </Router>
          </SnackbarProvider>
        </Provider>
      </MsalProvider>
    </ErrorBoundary>
  </>
);

serviceWorkerRegistration.register();
// serviceWorkerRegistration.unregister();
reportWebVitals();
